import React from 'react'
import data from './data.json'
import {
  Intro,
  Layout,
  Header,
  SectionTitle,
  Grid,
  GridItem,
} from '../../../../components'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Use words for numbers through nine, then numerals for 10 and beyond,
            generally following AP Stylebook rules. Some limited exceptions and
            additional guidelines are provided here.
          </p>
        </Intro>
        <SectionTitle>Age</SectionTitle>
        <p>
          Always use numerals when referring to the age of a person or object.
          Never spell out any ages.
        </p>
        <Grid>
          <GridItem columns="6">
            <div class="do">
              <div class="do__title">
                <i class="icon icon--success"></i> Do
              </div>
              <p class="u-type--medium">You must be at least 18 years old.</p>
            </div>
          </GridItem>
          <GridItem columns="6">
            <div class="dont">
              <div class="dont__title">
                <i class="icon icon--error"></i> Don't
              </div>

              <p class="u-type--medium">You must be at least eighteen.</p>
            </div>
          </GridItem>
        </Grid>

        <SectionTitle>Currency</SectionTitle>
        <p>
          Always include commas for values with four digits or more: $2,500.
          When used in copy, no decimals should be included in a currency value
          unless the value requires it. Use $25 for twenty-five dollars even,
          and $25.48 for twenty-five dollars and forty-eight cents. Form fields
          should always include the decimal ($25.00).
        </p>

        <SectionTitle>Dates</SectionTitle>
        <p>
          Spell out the month when writing dates. The day follows the month and
          does not use cardinal notation such as "st" or "th." There is a comma
          between the day and the year. For example: August 28, 2016.
        </p>
        <p>
          Only write dates in numerical format when it's not possible to spell
          out the month in the space provided. Do not include zeros before
          single digits. For example: 8/28/2016 or 12/25/2019.
        </p>

        <SectionTitle>Numerals</SectionTitle>
        <p>
          You should generally use words for numbers through nine and numerals
          at 10 and above. However, always use numerals to represent any
          numerical data in tables or form fields. When the word “one” is
          serving as an adjective, article or pronoun, spell out the word “one”
          (i.e. “one of these”). Use en dashes to separate ranges of numbers.
        </p>

        <SectionTitle>Percentages</SectionTitle>
        <p>
          Use the percent symbol (%) when indicating percentages in tables,
          charts, form fields, quotes or otherwise.
        </p>

        <SectionTitle>Phone Numbers</SectionTitle>
        <p>
          U.S. phone numbers should be formatted as follows: (555) 555-5555.
        </p>

        <SectionTitle>Time</SectionTitle>
        <p>
          Use numerals and capitalized day parts (AM/PM) when writing out a
          time. For single digit times (1 PM–9 PM), do not use zeros in front of
          the number. When the time is on the hour (2 PM), do not use zeros.
        </p>

        <SectionTitle>Time Zones</SectionTitle>
        <p>
          Times represented on our digital properties reflect the bank footprint
          of Eastern Time Zone. Include "ET" after times if there will be
          confusion.
        </p>
      </Layout>
    </>
  )
}
